module.exports = __webpack_public_path__ + "static/media/showroom.bbac42a4.svg";